import React from "react";
import { Modal, Button } from "react-bootstrap";

/**
 * The ApplicationModal component renders a modal with information about a Premium Plan subscription
 * and options to compare plans.
 * @returns The `ApplicationModal` component is being returned. It contains a modal dialog with
 * information about the Premium Plan subscription, a button to compare plans, and a list of things to
 * know about the subscription. The modal also includes some commented-out code for additional features
 * that are not currently displayed.
 */

const ApplicationModal = () => {
  return (
    <>
      <Modal.Header closeButton style={{ borderBottom: "none" }} />
      <Modal.Body>
        <p
          style={{
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "18px",
          }}
        >
          Get started with Premium Plan at USD $31.25 per month
        </p>

        {/* <p style={{ textAlign: "left" }}>
              Analyze your commercial viability while building your business
              plan.
            </p> */}

        <div style={{ textAlign: "center" }}>
          <a
            href="https://www.roiquant.com/pricing"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button className="modal-compare glintanimation">
              Compare plans
            </Button>
          </a>
        </div>

        <hr style={{ margin: "1.5rem 0" }} />

        <p style={{ fontWeight: "bold", marginBottom: "0" }}>Things to know:</p>

        <ul className="modal-list">
          <li>Downgrade your subscription plan at any time</li>
          <li>Once payment is made, there is no refund</li>
          <li>
            If you downgrade or cancel, you will no longer have access to the
            features that are only available in the subscription plan which you
            downgraded or cancelled from
          </li>
        </ul>

        {/* <div style={{ textAlign: "center" }}>
              <a
                href="https://www.roiquant.com/tools/founders/business-plan-builder"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button className="modal-product glintanimation">
                  Learn more about the product
                </Button>
              </a>
            </div> */}
      </Modal.Body>
    </>
  );
};
export default ApplicationModal;
